import React, { useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Lottie from 'lottie-react'
import animationData from '../../animations/animation.json'

const Hero = () => {

  const lottieRef = useRef(null);

  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.goToAndPlay(45, true);
    }
  }, []);

  return (

    <div className='pt-2 pb-2 px-4 overflow-hidden'>
      {/* <div className='pt-2 pb-2 px-4 overflow-hidden bg-gradient-to-b from-gray-100 via-white to-blue-500/30'> */}
      <div className='flex flex-col md:flex-row text-center md:text-left text-black py-2 px-4 max-w-[1200px] mx-auto'>
        <div className='flex-1 max-w-[600px] mx-auto md:mr-8'>
          <h2 className=' text-5xl md:text-6xl font-bold pt-12 md:pt-16 pb-4 md:pb-8'><span className='text-[#3fc07c]'>Website Services</span> For Your Business</h2>
          {/* <h2 className=' text-5xl md:text-6xl font-bold pt-12 md:pt-16 pb-4 md:pb-8 text-black'>Website Solutions For Your Business</h2> */}
          <p className=' text-gray-900 pb-4 md:pb-8 '>Website development and design services custom tailored to help increase and grow your online presence.</p>
          {/* <p className='text-lg md:text-2xl text-gray-900 pb-8 md:pb-16'>Website development and design services custom tailored to help increase and grow your online presence.</p> */}
          <p className='pb-16 text-gray-400'>Website Design - Website Development - Hosting - Business Email</p>


          <Link to='/projects' className='inline-flex bg-[#3fc07c] hover:bg-[#34c6eb] text-white py-2 px-4 mr-4'>
            View Projects
          </Link>

          <Link to='/form' className='inline-flex bg-white text-[#3fc07c] rounded-full py-2 px-4 mr-4'>
            Get Started
          </Link>

        </div>
        <div className='flex-1 max-w-[600px] mx-auto overflow-hidden'>
          <Lottie
            lottieRef={lottieRef}
            animationData={animationData}
            loop={false}
            autoplay={true}
            className='w-[250px] md:w-[550px]' />

        </div>
      </div>
    </div>

  )
}

export default Hero